import { render, staticRenderFns } from "./MessageTemplates.vue?vue&type=template&id=7f88c9bc&"
import script from "./MessageTemplates.vue?vue&type=script&lang=js&"
export * from "./MessageTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports